export default "__VITE_ASSET__Bg2_yFso__"